<template>
    <coupon-redeem-form-base>
        <template slot-scope="{ redeemCoupon, code, updateCode, errors }">
            <div class="coupon-redeem-form">
                <div
                    v-if="errors"
                    class="alert alert-danger"
                >
                    <span
                        v-for="(error, index) in errors[0]"
                        :key="index"
                    >
                        {{ error }}
                    </span>
                </div>
                <div class="input-group">
                    <label for="code">{{ __('Enter the coupon code!') }}</label>
                    <input
                        id="code"
                        :value="code"
                        type="text"
                        required
                        @input="updateCode"
                    >
                </div>
                <button
                    class="btn btn-primary"
                    @click="redeemCoupon(code)"
                >
                    {{ __('Redeem') }}
                </button>
            </div>
        </template>
    </coupon-redeem-form-base>
</template>

<script>
export default {
    name: 'CouponRedeemForm'
}
</script>